import React, { useState } from 'react';
import { View, Text, TextInput, TouchableOpacity, ActivityIndicator, StyleSheet } from 'react-native';
import { useForgotPasswordMutation } from '../../store/api';
import { useTheme } from '../../theme/ThemeContext';
import { COLORS, getThemeStyles, globalStyles } from '../../theme/designSystem';

export const ForgotPasswordScreen = ({ navigation }: any) => {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [forgotPasswordApi, { isLoading }] = useForgotPasswordMutation();
  const { isDark } = useTheme();
  const theme = getThemeStyles(isDark);

  const handleReset = async () => {
    if (!email) return;
    try {
      await forgotPasswordApi({ email }).unwrap();
      setSubmitted(true);
    } catch (err) {
      setSubmitted(true);
    }
  };

  return (
    <View style={[styles.container, { backgroundColor: theme.bg }]}>
      <View style={styles.cardWrapper}>
        <View style={[globalStyles.card, { backgroundColor: theme.cardBg, borderColor: theme.border }]}>
          <Text style={[styles.title, { color: theme.textPrimary }]}>Reset Password</Text>
          <Text style={[styles.subtitle, { color: theme.textSecondary }]}>
            Enter your registered work email to receive password recovery instructions.
          </Text>

          {submitted ? (
            <View style={styles.successBox}>
              <Text style={styles.successText}>
                ✓ Instructions sent! If an account exists for {email}, a recovery email has been dispatched.
              </Text>
            </View>
          ) : (
            <>
              <Text style={[styles.label, { color: theme.textPrimary }]}>Email Address</Text>
              <TextInput
                value={email}
                onChangeText={setEmail}
                placeholder="user@aeroflow.com"
                placeholderTextColor={theme.textSecondary}
                keyboardType="email-address"
                autoCapitalize="none"
                style={[
                  globalStyles.input,
                  {
                    backgroundColor: theme.inputBg,
                    borderColor: theme.border,
                    color: theme.textPrimary,
                  },
                ]}
              />

              <TouchableOpacity
                onPress={handleReset}
                disabled={isLoading}
                style={[globalStyles.buttonPrimary, { marginTop: 8, marginBottom: 12 }]}
              >
                {isLoading ? (
                  <ActivityIndicator color="#fff" />
                ) : (
                  <Text style={globalStyles.buttonText}>Send Recovery Email</Text>
                )}
              </TouchableOpacity>
            </>
          )}

          <TouchableOpacity onPress={() => navigation.goBack()} style={{ paddingVertical: 8 }}>
            <Text style={styles.backText}>← Back to Sign In</Text>
          </TouchableOpacity>
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    padding: 24,
    justifyContent: 'center',
  },
  cardWrapper: {
    maxWidth: 480,
    width: '100%',
    alignSelf: 'center',
  },
  title: {
    fontSize: 22,
    fontWeight: '800',
    marginBottom: 6,
  },
  subtitle: {
    fontSize: 12,
    marginBottom: 20,
    lineHeight: 18,
  },
  label: {
    fontSize: 12,
    fontWeight: '700',
    marginBottom: 6,
  },
  successBox: {
    padding: 14,
    borderRadius: 12,
    backgroundColor: COLORS.successBg,
    borderWidth: 1,
    borderColor: COLORS.success,
    marginBottom: 20,
  },
  successText: {
    color: COLORS.success,
    fontSize: 12,
    fontWeight: '700',
    textAlign: 'center',
    lineHeight: 18,
  },
  backText: {
    color: COLORS.primary,
    fontSize: 13,
    fontWeight: '700',
    textAlign: 'center',
  },
});
